import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { Button, Text } from '@pancakeswap-libs/uikit'
import { AlertTriangle } from 'react-feather'
import Modal from '../Modal'
import { AutoRow, RowBetween } from '../Row'
import { AutoColumn } from '../Column'

const WarningContainer = styled.div`
  max-width: 420px;
  width: 100%;
  padding: 1rem;
  background: rgba(242, 150, 2, 0.05);
  border: 1px solid #f3841e;
  border-radius: 20px;
  overflow: auto;
`

const StyledWarningIcon = styled(AlertTriangle)`
  stroke: ${({ theme }) => theme.colors.binance};
`

export default function SafeMoonWarningModal({ isOpen, onConfirm }: { isOpen: boolean; onConfirm: () => void }) {
  const [understandChecked, setUnderstandChecked] = useState(false)
  const toggleUnderstand = useCallback(() => setUnderstandChecked((uc) => !uc), [])

  const handleDismiss = useCallback(() => null, [])
  return (
    <Modal isOpen={isOpen} onDismiss={handleDismiss} maxHeight={90}>
      <WarningContainer className="token-warning-container">
        <AutoColumn gap="lg">
          <AutoRow gap="6px">
            <StyledWarningIcon />
            <Text>เตือนทุกท่าน</Text>
          </AutoRow>
          <>
            <Text>
             {' '}
               สำหรับเหรียญที่ Kuy List มาในระบบนั้น!! 
               Kuy อยากจะ List ทุกๆ Token ที่อยู่บน KuySWAP ครับ
            </Text>
            <Text>ทางเรารับประกันไม่ได้ว่า Token นั้นๆ จะ SCAM / RUG PULL ท่านหรือไม่</Text>
            <Text>ทาง Kuy แค่ทำให้ Token นั้นหาง่ายขึ้นแค่นั้นเองครับ</Text>
            <Text>การตัดสินใจ อยู่กับพวกท่านนายฮ้อยทั้งหลาย </Text>
            <Text>เงินของท่านตัดสินใจกันดีๆ นะครับ </Text>
            <Text>รักและห่วงใยจากใจ</Text>
            <Text>#KUYCOIN #KUYSWAP</Text>
            <Text>โปรดระมัดระวังในการลงทุนทุกครั้ง</Text>
          </>
          <RowBetween>
            <div>
              <label htmlFor="understand-checkbox" style={{ cursor: 'pointer', userSelect: 'none' }}>
                <input
                  id="understand-safeMoonWarning"
                  type="checkbox"
                  className="understand-checkbox"
                  checked={understandChecked}
                  onChange={toggleUnderstand}
                />{' '}
                <Text as="span">ยอมรับ</Text>
              </label>
            </div>
            <Button
              id="confirm-safeMoonWarning"
              disabled={!understandChecked}
              variant="danger"
              style={{ width: '140px' }}
              onClick={() => {
                setUnderstandChecked(false)
                onConfirm()
              }}
            >
              ตกลง
            </Button>
          </RowBetween>
        </AutoColumn>
      </WarningContainer>
    </Modal>
  )
}
